<template>
  <div class="h-screen flex flex-col overflow-hidden">
    <DjHeader class="flex-shrink-0" />
    <div class="flex-1 overflow-y-auto relative z-0">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineOptions({
    name: 'Header',
  });
</script>
